(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('.fdl-header-drawer a[href]');
    if (!link || link.href !== window.location.href) return;
    const toggle = link.closest('header-drawer')?.querySelector(':scope > details[open] > summary');
    if (toggle) toggle.click();
  });
  } catch(e) { console.error(e); }
})();

})();
